export default __webpack_public_path__ + "static/img/manor.f881ff2.jpg";